(function () {
  'use strict';

  angular
      .module('tfc.retailer.Consumer')
      .factory('ConsumerReports', ConsumerReports);

  // @ngInject
  function ConsumerReports(Api, BRAND_URL) {
    var BASE_URL = '/consumer';

    return {
      getAgeAggregations : getAggregationsFn("/age"),
      getGenderAggregations : getGenderAggregations,
      getWeightAggregations : getAggregationsFn("/weight"),
      getHeightAggregations : getAggregationsFn("/height"),
      getInseamAggregations : getAggregationsFn("/inseam"),
      getFootLengthAggregations : getAggregationsFn("/footLength"),
      getBustSizeAggregations : getAggregationsFn("/bustSize"),
      getConsumerProfileFilters: getConsumerProfileFilters,
      findBrandNames : findBrandNames
    };

    function getAggregationsFn(path) {
      return function (brandKey, gender, region, transaction) {
        return Api.get(BASE_URL + path, {
          params: {brandKey: brandKey, gender: gender, region: region, transaction: transaction}
        }).then(_.property('data'));
      }
    }

    function getGenderAggregations(brandKey, region, transaction) {
      return Api.get(BASE_URL + '/gender', { params: { brandKey: brandKey, region: region,
          transaction: transaction }}).then(_.property('data'))
    }

    function getConsumerProfileFilters(brandKey) {
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + '/report/consumer/filters',{ cache: true } ).then(_.property('data'));
    }

    function findBrandNames() {
      return Api.get(BASE_URL + '/brands', { cache : true })
          .then(_.property('data'));
    }

  }

})();
